/* eslint-disable */
import { AxiosInstance, AxiosResponse } from 'axios'
import { Exactly } from './utils'

export type OperationWithAxiosResponse = <T extends Exactly<Request, T>>(request: T) => Promise<AxiosResponse<Response>>
export const operationWithAxiosResponse = <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<AxiosResponse<Response>> => {
  return axios.request({
    url: `/verify-passkey-login`,
    // @ts-ignore for sm-axios
    urlTemplate: '/verify-passkey-login',
    method: 'POST',
    headers: request.headers,
    data: request.body,
  })
}

/**
 * verify the user passkey login
 */
export type Operation = <T extends Exactly<Request, T>>(request: T) => Promise<Response>
export const operation = async <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<Response> => {
  return (await operationWithAxiosResponse(axios, request)).data
}

export interface Request {
  headers?: {
    'x-sm-trace-token'?: string
  }
  body: {
    token: string
    /**
     * a jwt represents a user device token
     */
    userDeviceToken: string
    /**
     * a login authentication state
     */
    state: string
  }
}

export interface Response {
  /**
   * a jwt represents a user device token
   */
  userDeviceToken: string
}

